export default __webpack_public_path__ + "static/media/Shield of the Shivering Stars.9392dbfd.jpg";